import template from './prems-premium-item.html.twig';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('prems-premium-item', {
    template,

    inject: [
        'repositoryFactory',
    ],

    mixins: [
        Mixin.getByName('listing'),
    ],


    data() {
        return {
            premiumItems: [],
            sortBy: 'premsPremiumItemProductOrder.count',
            sortDirection: 'DESC',
            isLoading: false,
            isAdvancedVersion: false
        };
    },

    computed: {
        repository() {
            return this.repositoryFactory.create('product');
        },

        criteria() {
            const criteria = new Criteria(this.page, this.limit);
            criteria.addFilter(Criteria.equals('customFields.prems_premium_item_plugin', true));

            this.sortBy.split(',').forEach((sortBy) => {
                criteria.addSorting(Criteria.sort(sortBy, this.sortDirection));
            });

            criteria.addAssociation('options.group');
            criteria.addAssociation('premsPremiumItemProductOrder');

            criteria
                .addSorting(Criteria.sort('createdAt'));

            return criteria;
        },

        premiumItemProductColumns() {
            return this.getPremiumItemProductColumns();
        },

        assetFilter() {
            return Shopware.Filter.getByName('asset');
        },

        mappedPremiumItems() {
            return [...this.premiumItems].map(item => {
                return {
                    ...item,
                    orderCount: item.extensions?.premsPremiumItemProductOrder?.count ?? 0
                };
            });
        },
    },

    watch: {
        premiumItemProductCriteria: {
            handler() {
                this.getList();
            },
            deep: true,
        },
    },

    created() {
        if (Shopware.InAppPurchase.isActive('PremsPremiumItem', 'premsPremiumItemAdvanced')) {
            this.isAdvancedVersion = true;
        }
        this.createdComponent();
    },

    methods: {
        createdComponent() {},

        async getList() {
            this.isLoading = true;

            try {
                const response = await this.repository.search(
                    this.criteria,
                    {
                        ...Shopware.Context.api,
                        inheritance: true,
                    }
                );

                this.total = response.total;
                this.premiumItems = response;
                console.log(response);
                this.isLoading = false;
            } catch {
                this.isLoading = false;
            }
        },

        getPremiumItemProductColumns() {
            return [
                {
                    property: 'name',
                    label: 'prems-premium-item.product.list.column-product',
                    routerLink: 'sw.product.detail',
                    allowResize: true,
                    primary: true,
                },
                {
                    property: 'productNumber',
                    label: 'prems-premium-item.product.list.column-product-number',
                    allowResize: true,
                    visible: true,
                },
                {
                    property: 'active',
                    label: 'sw-product.list.columnActive',
                    inlineEdit: 'boolean',
                    allowResize: true,
                    align: 'center',
                },
                {
                    property: 'orderCount',
                    label: 'prems-premium-item.product.list.column-count',
                    allowResize: true,
                    visible: true,
                }
            ];
        },
    }
});